import { useMe } from './api';
import { createContext, useContext, useState, type ReactNode } from 'react';

// Shared across Overview, Conversations, Rescue and Leaderboard: 'all', 'none' (unassigned) or a rep id.
export type RepFilterValue = 'all' | 'none' | string;

const Ctx = createContext<{ value: RepFilterValue; set: (v: RepFilterValue) => void }>({ value: 'all', set: () => {} });

const KEY = 'coachrex.repFilter';

function read(): RepFilterValue {
  try {
    return sessionStorage.getItem(KEY) ?? 'all';
  } catch {
    return 'all';
  }
}

export function RepFilterProvider({ children }: { children: ReactNode }) {
  const [value, setValue] = useState<RepFilterValue>(read);
  const set = (v: RepFilterValue) => {
    setValue(v);
    try {
      sessionStorage.setItem(KEY, v);
    } catch {
      /* storage unavailable */
    }
  };
  return <Ctx.Provider value={{ value, set }}>{children}</Ctx.Provider>;
}

/** Reps only ever see their own leads, so for them the filter is always "all" (of theirs). */
export function useRepFilter() {
  const ctx = useContext(Ctx);
  const me = useMe();
  return me.data?.user.role === 'rep' ? { value: 'all' as RepFilterValue, set: () => {} } : ctx;
}

export function matchesRep(filter: RepFilterValue, repId: string | null | undefined): boolean {
  if (filter === 'all') return true;
  if (filter === 'none') return !repId;
  return repId === filter;
}
